const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'square',
  strokeLinejoin: 'miter',
  'aria-hidden': true,
};

export const Spotify = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M7 9.5c3.5-1 7-.7 10 1" />
    <path d="M7.6 12.6c2.8-.8 5.6-.5 8 .8" />
    <path d="M8.2 15.5c2.2-.5 4.3-.3 6.2.7" />
  </svg>
);

export const SoundCloud = (props) => (
  <svg {...base} {...props}>
    <path d="M10 17.5h8a3.5 3.5 0 0 0 .4-7A5.5 5.5 0 0 0 10 8.2z" />
    <path d="M7.5 10v7.5M5 11.5v6M2.5 13.5v3.5" />
  </svg>
);

export const YouTube = (props) => (
  <svg {...base} {...props}>
    <rect x="2" y="5" width="20" height="14" />
    <path d="M10 9.2v5.6l4.8-2.8z" fill="currentColor" />
  </svg>
);

export const Instagram = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="3" width="18" height="18" />
    <circle cx="12" cy="12" r="4" />
    <path d="M17 7h.01" />
  </svg>
);

// Arrows and marks drawn as SVG rather than text characters, which phones swap for emoji.
// Sized in em so they follow the surrounding text.
const mark = { ...base, strokeWidth: 1.75, width: '0.8em', height: '0.8em', className: 'inline-block shrink-0' };

export const ArrowUpRight = (props) => (
  <svg {...mark} {...props}>
    <path d="M7 17 17 7M8 7h9v9" />
  </svg>
);

export const ArrowRight = (props) => (
  <svg {...mark} {...props}>
    <path d="M4 12h16M14 6l6 6-6 6" />
  </svg>
);

export const ArrowLeft = (props) => (
  <svg {...mark} {...props}>
    <path d="M20 12H4M10 6l-6 6 6 6" />
  </svg>
);

export const Close = (props) => (
  <svg {...mark} {...props}>
    <path d="M6 6l12 12M18 6 6 18" />
  </svg>
);

export const Caret = (props) => (
  <svg {...mark} stroke="none" fill="currentColor" {...props}>
    <path d="M8 5v14l11-7z" />
  </svg>
);
